import { SplitTreatments } from "@splitsoftware/splitio-react";
import { BenefitTypeEnum } from "v2/domain/common/entities/BenefitType";
import configLifeInsuranceBenefit from "../../../../../usecases/benefit-model/configLifeInsuranceBenefit";
import { translate as t } from "../../../../../infrastructure/translate/localization";
import lifeInsuranceBenefitImageV2 from "../../../../../assets/img/v2/life-insurance-benefit.png";
import lifeInsuranceBenefitDisabledImageV2 from "../../../../../assets/img/v2/life-insurance-benefit-disabled.png";
import BenefitCard from "../../BenefitCard";
import featureFlagsDictionary from "../../../../../infrastructure/split/feature-flags-dictionary";
import { BenefitCategory } from "../../../../../v2/domain/common/entities/BenefitCagetory";
import { CountryIsoCode } from "../../../../../v2/domain/common/enums/CountryISOCode";

const LifeInsuranceTab = ({
  selectedTab,
  toggleActive,
  country,
  companyId,
}: {
  selectedTab: {
    id: string;
    lifeInsuranceBenefit: boolean;
    lifeInsuranceConfigs: any;
  };
  toggleActive: (id: string, benefit: string) => void;
  country: CountryIsoCode;
  companyId: string;
}) => {
  return (
    <SplitTreatments
      names={[featureFlagsDictionary.BI_264]}
      attributes={{
        companyId,
        countryISOCode: country,
        benefit: BenefitCategory.LIFE_INSURANCE,
      }}
    >
      {({ treatments, isReady }) => {
        const isActiveTreatment =
          treatments[featureFlagsDictionary.BI_264].treatment === "on";

        const benefitProps =
          isReady && isActiveTreatment
            ? {
                hasV2Screen: true,
                handleSeeMore: () =>
                  window.location.assign(
                    `/v2/benefits/compensation-plan/${selectedTab.id}/life-insurance?tab=information`
                  ),
              }
            : {
                tooltipText: t(
                  "benefits-section.life-insurance-benefit.benefit-model-tooltip"
                ),
                advanced: true,
                requestInfo: selectedTab.lifeInsuranceConfigs.length === 0,
                handleAdvance: () =>
                  configLifeInsuranceBenefit({ selectedTab }),
                handleActiveToggle: () =>
                  toggleActive(selectedTab.id, "lifeInsuranceBenefit"),
              };

        return (
          <BenefitCard
            benefit={BenefitTypeEnum.LIFE_INSURANCE_BENEFIT}
            title={t("benefits-section.life-insurance-benefit.life-insurance")}
            image={
              selectedTab.lifeInsuranceBenefit
                ? lifeInsuranceBenefitImageV2
                : lifeInsuranceBenefitDisabledImageV2
            }
            active={selectedTab.lifeInsuranceBenefit}
            country={country}
            {...benefitProps}
          />
        );
      }}
    </SplitTreatments>
  );
};

export default LifeInsuranceTab;
